import { useQuery, useMutation, useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import { organizationRequest } from './services';
import { can } from '../../permissions';
const profilePath = (id) => (id ? `organizadora/${id}/perfil` : 'minha-organizadora');
export function useOrganizationBranding() {
  const { token, user } = useSelector((s) => s.AppReducer);
  return useQuery(
    ['organizadora', user?.id, 'branding'],
    () => organizationRequest(token, 'organizadora/contexto').then((r) => r.data),
    {
      enabled: !!token && !!user?.empresa?.id,
      staleTime: 5 * 60 * 1000,
      retry: false,
    }
  );
}
export function useMyOrganization(id) {
  const { token, user } = useSelector((s) => s.AppReducer);
  return useQuery(
    ['organizadora', user?.id, 'details', id || 'own'],
    () => organizationRequest(token, profilePath(id)).then((r) => r.data),
    {
      enabled: !!token,
      retry: false,
    }
  );
}
export function useSaveOrganization(id, creating = false) {
  const { token, user } = useSelector((s) => s.AppReducer),
    cache = useQueryClient();
  return useMutation((data) => organizationRequest(token, creating ? 'faculdade/store_organizadora' : profilePath(id), 'POST', data).then(response => {
    if (response.errors || response.error) {
      const error = new Error('Não foi possível salvar a organizadora.');
      error.fields = response.errors || { error: response.error };
      throw error;
    }
    return response;
  }), {
    onSuccess: () =>
      Promise.all([
        cache.invalidateQueries(['organizadora', user?.id]),
        cache.invalidateQueries(['portal']),
      ]),
  });
}
export function useOrganizationCredentials(id) {
  const { token } = useSelector((s) => s.AppReducer);
  return useMutation(() =>
    organizationRequest(token, profilePath(id) + '/credenciais').then((r) => r.data)
  );
}
export function usePositionSource(empresa, faculdade, processo) {
  const { token, user } = useSelector((s) => s.AppReducer),
    cache = useQueryClient();
  const path = `organizadora/${empresa}/seletivos/${faculdade}/cargos/${processo}/inscricoes`,
    key = ['portal-position', user?.id, empresa, faculdade, processo];
  const query = useQuery(key, () => organizationRequest(token, path).then((r) => r.data), {
    enabled: !!empresa && !!faculdade && !!processo,
    retry: false,
  });
  const save = useMutation((data) => organizationRequest(token, path, 'PUT', data), {
    onSuccess: () => cache.invalidateQueries(key),
  });
  return { query, save: { ...save, allowed: can(user, 'portal_configuracoes', 'edit') } };
}
